export default __webpack_public_path__ + "static/media/logout.72d56cad.svg";